import React, { FC } from 'react';

import { ImageComponent } from '@/components/Image';

import { ScBadge } from './styled';

type BadgeType =
  | 'wagering'
  | 'top'
  | 'new'
  | 'tournament'
  | 'exclusive'
  | 'instant'
  | 'jackpot'
  | 'heart';

const MAP_CATEGORY_TO_ICON = {
  wagering: { src: '/wageringIcon.webp' }, // Circle
  exclusive: { src: '/exclusiveIcon.webp' }, // LUP
  top: { src: '/topIcon.webp' }, // Fire
  tournament: { src: '/tournamentIcon.webp' }, // Cup
  instant: { src: '/instantIcon.webp' }, // Lighting
  jackpot: { src: '/diamondIcon.webp' }, // Diamond
  heart: { src: '/emojis/heart.webp' }, // Heart
};

export interface IBadgeProps {
  type: BadgeType;
  className?: string;
}

export const Badge: FC<IBadgeProps> = ({ type, className }) => {
  return (
    <ScBadge className={className} type={type}>
      {type === 'new' ? (
        <span>new</span>
      ) : (
        <ImageComponent
          width={14}
          height={14}
          src={MAP_CATEGORY_TO_ICON[type].src}
          alt="badge"
        />
      )}
    </ScBadge>
  );
};
